import appLocaleData from 'react-intl/locale-data/hi';
import hiMessages from '../locales/hi_HI';

const HiLang = {
    messages: {
        ...hiMessages
    },
    locale: 'hi-HI',
    data: appLocaleData
};
export default HiLang;